<template>
  <div>
    <!-- 第一层 -->
    <template v-if="item.visible == 0">
      <!-- 如果第一层有子菜单，则继续循环 -->
      <template v-if="item.children && item.children.length > 0">
        <el-submenu :index="item.path">
          <template slot="title">
            <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title">{{ (navigationMode === 'leftVertical' && (isCollapse && isTitle)) ? '' : item.menuName }}</span>
          </template>
          <!-- 第二层 -->
          <!-- <common-menu-item-aside :menuItemData="item.children"></common-menu-item-aside> -->
          <common-menu-item-aside v-for="(child, index) in item.children" :item="child"
            :key="child.path + index"></common-menu-item-aside>
        </el-submenu>
      </template>
      <!-- 如果第一层没有子菜单 -->
      <template v-else>
        <el-menu-item @click="clickMenu(item)" :index="item.path == 'cockpit' ? '' : item.path">
          <i :class="`el-icon-${item.icon}`"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
import CommonMenuItemAside from "./CommonMenuItemAside.vue";
export default {
  name: "CommonMenuItemAside",
  components: {
    CommonMenuItemAside
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    clickMenu(item) {
      const menuData = {
        path: item.path,
        redirect: item.redirect || false,
        query: item.query || null,
        menuName: item.menuName
      };
      this.$store.dispatch('updateMenuItem', menuData);
      if (this.checkRouter({ path: item.path })) {
        if (item.query && item.query.length > 0) {
          this.$router.push(item.query + item.path);
        } else {
          this.$router.push(item.path);
        }
      }
    },
    // 当前页面路由与跳转路由不一致时才允许跳转
    checkRouter(data) {
      // console.log(this.$route.path, data, data.path);
      return (
        // 当前路由     要跳转的路由
        // 有重定向（redirect）的时候，当前路由不等于被跳转的路由（最终url）并且
        this.$route.path !== data.path &&
        !(this.$route.path === "/dashboard" && data.path === "dashboard") &&
        !(this.$route.path === "/userList" && data.path === "userList") &&
        !(this.$route.path === "/roleList" && data.path === "roleList") &&
        !(this.$route.path === "/menuList" && data.path === "menuList") &&
        !(this.$route.path === "/deptList" && data.path === "deptList") &&
        !(this.$route.path === "/logsList" && data.path === "logsList") &&
        !(this.$route.path === "/menuListTenant" && data.path === "menuListTenant") &&
        true
      );
    },
  },
  computed: {
    isCollapse() {
      return this.$store.state.tab.isCollapse;
    },
    // 导航栏模式 
    navigationMode() {
      return this.$store.state.settings.navigationMode;
    },
  },
};
</script>
